/* Coffee Description — Blend
   Component switcher (any number of components), story Read more, profile tooltips.
   Idempotent init, handles shopify:section:load / select / unload. */
(function () {
  'use strict';

  var SECTION = '[data-coffee-desc-blend]';

  function show(root, index) {
    root.querySelectorAll('[data-cdb-tab]').forEach(function (tab) {
      var on = tab.dataset.cdbTab === index;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
    });

    ['[data-cdb-pane]', '[data-cdb-stats]'].forEach(function (sel) {
      root.querySelectorAll(sel).forEach(function (el) {
        var key = el.dataset.cdbPane || el.dataset.cdbStats;
        var on = key === index;
        el.classList.toggle('is-hidden', !on);
        if (on) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });
    });
  }

  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-cdb-tab]'));
    if (!tabs.length) return;

    tabs.forEach(function (tab, i) {
      if (tab.dataset.cdbBound === 'true') return;
      tab.dataset.cdbBound = 'true';

      tab.addEventListener('click', function () {
        show(root, tab.dataset.cdbTab);
      });

      tab.addEventListener('keydown', function (event) {
        var step = 0;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') step = 1;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') step = -1;
        if (!step) return;
        event.preventDefault();
        var next = tabs[(i + step + tabs.length) % tabs.length];
        show(root, next.dataset.cdbTab);
        next.focus();
      });
    });
  }

  function initStory(root) {
    var story = root.querySelector('[data-cdb-story]');
    var button = root.querySelector('[data-cdb-more]');
    if (!story || !button) return;

    var inner = story.querySelector('[data-cdb-story-inner]');
    if (!inner) return;

    if (button.getAttribute('aria-expanded') !== 'true') {
      story.classList.add('is-clamped');
      var overflows = inner.scrollHeight - inner.clientHeight > 2;
      button.hidden = !overflows;
      if (!overflows) story.classList.remove('is-clamped');
    }

    if (button.dataset.cdbBound === 'true') return;
    button.dataset.cdbBound = 'true';

    button.addEventListener('click', function () {
      var expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      story.classList.toggle('is-clamped', expanded);
      button.textContent = expanded
        ? button.dataset.cdbMoreText || 'Read more'
        : button.dataset.cdbLessText || 'Read less';
    });
  }

  function closeTips(root) {
    root.querySelectorAll('[data-cdb-tip].is-open').forEach(function (tip) {
      tip.classList.remove('is-open');
    });
  }

  function initTips(root) {
    root.querySelectorAll('[data-cdb-tip]').forEach(function (tip) {
      if (tip.dataset.cdbBound === 'true') return;
      tip.dataset.cdbBound = 'true';

      tip.addEventListener('click', function (event) {
        event.stopPropagation();
        var open = tip.classList.contains('is-open');
        closeTips(root);
        tip.classList.toggle('is-open', !open);
      });

      tip.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') tip.classList.remove('is-open');
      });

      tip.addEventListener('blur', function () {
        tip.classList.remove('is-open');
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll(SECTION).forEach(function (root) {
      initTabs(root);
      initStory(root);
      initTips(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('click', function () {
    document.querySelectorAll(SECTION).forEach(closeTips);
  });

  window.addEventListener('resize', function () {
    init();
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    closeTips(event.target);
  });
})();
